export const agentUpdateActions = [
  'EnableAgent',
  'SubscribeAgent',
  'AllowEnableAgent',
  'SetAgentPriority',
  'SetAgentLoggingLevel',
  'SetAgentAssignPriority',
  'AgentClearCashe',
  'AllowRemoteAdmin',
  'SetBuildGroup',
  'SetBuildPriority',
  'ResizeAgentCache',
];
Object.freeze(agentUpdateActions);

export const agentInvalidUpdateActionsNamesArray = [
  'EnableAgent',
  'AllowEnableAgent',
  'SetAgentAssignPriority',
  'SetBuildPriority',
  'SetBuildGroup',
  'CreateGroup',
  'SetAgentLoggingLevel',
  'ResizeAgentCache',
  'AgentClearCashe',
];
Object.freeze(agentInvalidUpdateActionsNamesArray);

export const agentFieldMapping = {
  EnableAgent: 'Enabled',
  SubscribeAgent: 'Status',
  AllowEnableAgent: 'AllowEnableAgent',
  // "SetAgentPriority": '',
  SetAgentLoggingLevel: 'LogLvl',
  SetAgentAssignPriority: 'AssignPriority',
  AgentClearCashe: 'AgentClearCashe',
  // "AllowRemoteAdmin": '',
  SetBuildGroup: 'buildGroup',
  SetBuildPriority: 'BuildPriority',
  ResizeAgentCache: 'ResizeAgentCache',
};
Object.freeze(agentFieldMapping);
